export type VariationFamilyMember = {
  id: string;
  parentVariationOfId?: string | null;
  clientIncluded?: boolean;
  variationLabel?: string | null;
};

export function variationFamilyRootId(member: VariationFamilyMember): string {
  return member.parentVariationOfId ?? member.id;
}

export function variationFamilyMembers<T extends VariationFamilyMember>(
  all: T[],
  member: T,
): T[] {
  const root = variationFamilyRootId(member);
  return all.filter(
    (row) => row.id === root || row.parentVariationOfId === root,
  );
}

export function countsTowardTcs<T extends VariationFamilyMember>(
  member: T,
  all: T[],
): boolean {
  const family = variationFamilyMembers(all, member);
  if (family.length <= 1) return member.clientIncluded !== false;
  const included = family.filter((row) => row.clientIncluded !== false);
  if (included.length === 0) return false;
  if (included.length === 1) return included[0].id === member.id;
  return member.clientIncluded !== false && !member.parentVariationOfId;
}

export function variationDelta(
  member: VariationFamilyMember & { total: number },
  all: Array<VariationFamilyMember & { total: number }>,
): number | null {
  const family = variationFamilyMembers(all, member);
  if (family.length <= 1 || !member.parentVariationOfId) return null;
  const primary = family.find((row) => !row.parentVariationOfId);
  if (!primary) return null;
  return member.total - primary.total;
}
